/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_y1 as y1,
} from "../../runtime/index.jsx";
export function Componente_U1_85_49(e) {
  return (
    <li
      key={`${e.acta}-${e.paso}`}
      className={`flex items-center justify-between gap-2`}
      children={[
        <span
          className={`min-w-0 truncate`}
          children={[
            <span aria-hidden={`true`} children={[y1(e.pasoNombre), ` `]} />,
            e.acta,
            ` · `,
            e.pasoNombre || `Paso ${e.paso + 1}`,
          ]}
        />,
        <span
          className={`shrink-0 text-xs text-(--text)`}
          children={[
            e.veces === 1 ? `1 vez` : `${e.veces} veces`,
            ` · al `,
            e.progresoPromedio,
            `%`,
          ]}
        />,
      ]}
    />
  );
}
